export default __webpack_public_path__ + "9fa45fc3724271b444a82265063786ab.ico";